import useDeleteExamination from './useDeleteExamination';

export default useDeleteExamination;
